/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import PlayPauseTrigger from './play-pause-trigger';

export * from './play-pause-trigger.props';

/**
 * Exporting the PlayPauseTrigger.
 */
export { PlayPauseTrigger };
